<template>
    <section class="video-fullscreen">
    <div class="video grayscale" data-overlay-dark="1">
        <div class="desgradado"></div>
      <video playsinline autoplay loop muted aria-label="Background Video">
        <source :src="videoMp4" type="video/mp4">
        <source :src="videoWebm" type="video/webm">
        <!-- Fallback for unsupported formats -->
        Your browser does not support HTML5 video.
      </video>
    
    </div>
    <div class="v-middle">
      <div class="container">
        <div class="text-left">
          <div class="mt-60">
            <h4 class="hZUCZe">{{ $t('Innovation and Technological Future') }}</h4>
            <h1 class="mb-10 text-h2-sans">{{ $t('Design, Development') }}<br>{{ $t('and Strategies') }}<br>{{ $t('that Make a Difference...') }}</h1>
            <ButtonContact />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import videoMp4 from '@/assets/videos/video.mp4'
import videoWebm from '@/assets/videos/video.webm'
import ButtonContact from '@/components/ButtonContact.vue'
export default {
    name: 'VideoprincipalComponet',
    components: {
      ButtonContact
    },
    data() {
        return {
            videoMp4,
            videoWebm,
        };
    },
    
  };
</script>
<style scoped>
section{
  padding: 0px !important;
  margin: 0px !important;
}
/* =======  Video Background style  ======= */
.video-fullscreen {
  display: block;
    overflow: hidden;
  }
  .video-fullscreen .video.grayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
  }
  .video-fullscreen .video {
      height: 100vh;
  }
  .video-fullscreen video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}


  .v-middle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0px;
    -webkit-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    z-index: 9;
}
  

  /**Responsive Style here */
  @media screen and (max-width: 991px) {
  .video-fullscreen {
    widows: 100%;
    height: auto;
  }
  
  .video-fullscreen .video {
    height: 70vh;
  }
  
  .video-fullscreen video {
    height: 70vh;
  }
  
  .v-middle {
    padding: 20px;
  }
  
  .video-fullscreen h1,
  .video-fullscreen[data-overlay-dark] h1 {
    font-size: 28px;
    line-height: 1.2;
  }
  
  .video-fullscreen h4,
  .video-fullscreen[data-overlay-dark] h4 {
    font-size: 16px;
  }
  

  .desgradado {
    height: 70vh; /* Alinea la superposición degradada a la altura del video */
  }
}

@media screen and (max-width: 575px) {
  .video-fullscreen h1,
  .video-fullscreen[data-overlay-dark] h1 {
    font-size: 28px;
  }

  .video-fullscreen h4,
  .video-fullscreen[data-overlay-dark] h4 {
    font-size: 18px;
  }

  .v-middle {
    padding: 10px;
    text-align: center;
  }
}
</style>